const questions = [
  {
    type: 'confirm',
    name: 'bootstrapApi',
    default: true,
    message: 'Bootstrap API related files?',
  },
];

export default questions;
